const NON_RETRYABLE_STATUSES = new Set([401, 403, 404]);

const readStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") return undefined;
  const status = (error as { response?: { status?: unknown } }).response?.status;
  return typeof status === "number" ? status : undefined;
};

export const isNonRetryableError = (error: unknown): boolean => {
  const status = readStatus(error);
  return status !== undefined && NON_RETRYABLE_STATUSES.has(status);
};

export const createQueryRetry =
  (maxRetries: number) =>
  (failureCount: number, error: unknown): boolean =>
    !isNonRetryableError(error) && failureCount < maxRetries;

/** Screen reads retry a 5xx or network error once. 401, 403 and 404 never retry. */
export const shouldRetryQuery = createQueryRetry(1);
